import { withStyles } from '@material-ui/styles';

import PropertyImportWidget from './PropertyImportWidget';
import styles from './styles';

export default withStyles(styles)(PropertyImportWidget);
